import { DAYS_FILTERS, DAYS_FROM_FILTER, HOURS_FILTERS, HOURS_FROM_FILTER } from "../constants";
import { getConfiguration } from "./configuration";
import { nHoursFromNow } from "./nHoursFromNow";
import { getLocaleTimestamp } from "./getLocaleTimestamp";
import { nDaysFromNow } from "./nDaysFromNow";

export function filterMatchesByTimestamp(matches, filter) {
    const conf = getConfiguration();
    if (HOURS_FILTERS.includes(filter)) {
        return matches.filter(match => {
            const maxTimestamp = nHoursFromNow(HOURS_FROM_FILTER[filter]);
            let timestamp = match.timestampDB;
            if (conf.dbutc) {
                timestamp = getLocaleTimestamp(match.timestampDB);
            }
            return timestamp <= maxTimestamp;
        });    
    } else if (DAYS_FILTERS.includes(filter)) {
        return matches.filter(match => {
            const maxDate = nDaysFromNow(DAYS_FROM_FILTER[filter]);
            const date = match.timestampDB.split(' ')[0];
            return date <= maxDate;
        });
    } else {
        return matches;
    }
}
